// extracted by mini-css-extract-plugin
module.exports = {"YoutubeVideo":"YoutubeVideo_YoutubeVideo__MJRTY"};